"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ = require("./../");

var _KontaktOvereniApi = require("./../api/gen/subjekty/KontaktOvereniApi");

var _KontaktOvereniApi2 = _interopRequireDefault(_KontaktOvereniApi);

var _TypKontaktu = require("./../api/gen/proxioapi/TypKontaktu");

var TypKontaktu = _interopRequireWildcard(_TypKontaktu);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Komponenta zobrazující informace o datových schránkách pro subjekt, který má pouze id ověření.
 */
// --
var SubjektOvereniDsInfo = function (_React$Component) {
    (0, _inherits3.default)(SubjektOvereniDsInfo, _React$Component);

    function SubjektOvereniDsInfo(props) {
        (0, _classCallCheck3.default)(this, SubjektOvereniDsInfo);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SubjektOvereniDsInfo.__proto__ || (0, _getPrototypeOf2.default)(SubjektOvereniDsInfo)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
            dsList: null
        };

        _this.componentIsUnmounting = false;
        return _this;
    }

    (0, _createClass3.default)(SubjektOvereniDsInfo, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.componentIsUnmounting = true;
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.fetchDs(this.props);
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.overeniId !== nextProps.overeniId) {
                this.fetchDs(nextProps);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var dsList = this.state.dsList;


            if (dsList === null) {
                return _react2.default.createElement(_.Loader, null);
            } else {
                return _react2.default.createElement(
                    "span",
                    null,
                    dsList.length > 0 ? dsList.map(function (ds) {
                        return ds.kontakt;
                    }).join(", ") : "-"
                );
            }
        }
    }]);
    return SubjektOvereniDsInfo;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.fetchDs = function (props) {
        var overeniId = props.overeniId;


        _KontaktOvereniApi2.default.getSubjektKontakty(overeniId, [TypKontaktu.DS]).then(function (list) {
            if (!_this2.componentIsUnmounting) {
                _this2.setState({ dsList: list });
            }
        });
    };
};

exports.default = SubjektOvereniDsInfo;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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